import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { Actions as COMPANYACTIONS } from '../../../store/actions/companyActions';
import { Actions as PAYMENTACTIONS } from "../../../store/actions/paymentActions";
import _ from 'lodash';
import { PlusIcon, XMarkIcon } from "@heroicons/react/20/solid";
import Select from 'react-select';
import { useForm, Controller } from 'react-hook-form';
import NotificationManager from "react-notifications/lib/NotificationManager";

const IssueInvoiceModal = ({
    isModalOpen,
    closeModal,
    bundleList,
    org,
    currency,
    issueCredits,
}) => {

    const orderedList = _.orderBy(bundleList, 'price', 'asc')

    const { watch, setValue, control, handleSubmit, register } = useForm()
    const bundle = watch("bundle")
    const reference = watch("reference")
    const [newInvoice, setNewInvoice] = useState(false)
    const [invoiceable, setInvoiceable] = useState(false)
    const [invoiceNumber, setInvoiceNumber] = useState('INV-')
    const [quantity, setQuantity] = useState(1)

    useEffect(() => {
        setValue('bundle', bundleList?.[0])
    }, [bundleList])

    useEffect(() => {
        setQuantity(1)
        if (!Number(bundle?.credits) == 1) {
            setInvoiceable(true)
        }
    }, [bundle])

    // useEffect(() => {
    //     console.log(newInvoice)
    // }, [newInvoice])

    const onSubmit = (data) => {
        data.bundleID = data.bundle.id
        delete data.bundle
        data.issueInvoice = invoiceable && newInvoice
        data.quantity = quantity
        data.invoiceNo = invoiceable && invoiceNumber.replace('INV-', '') ? invoiceNumber : null

        if (!invoiceable || (!newInvoice ? invoiceNumber.replace('INV-', '') : newInvoice)) {
            issueCredits(data)
            // console.log(data)
        } else {
            NotificationManager.error('Please Enter A Valid Invoice Number', 'Error')
        }
    }

    if (!isModalOpen)
        return null

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto" }}>
                <div className="modal-dialog" style={{ width: "800px", maxWidth: "95%", background: "white", maxHeight: "calc(100% - 151px)" }}>
                    <div className="modal-content">
                        <div className="block block-themed block-transparent remove-margin-b" style={{ paddingBottom: 60 }}>
                            <div className="block-header bg-primary-dark" style={{ padding: 20 }}>
                                <ul className="block-options">
                                    <li>
                                        <button onClick={closeModal} type="button"><XMarkIcon className="h-6 w-6 mr-3 text-white" /></button>
                                    </li>
                                </ul>
                                <h3 className="block-title">Issue Credits To {org?.businessDetails.name}</h3>
                            </div>
                            <div className="block-content" style={{ padding: 20, paddingTop: 40 }}>

                                <div className="col-sm-6" style={{ paddingLeft: 0 }}>
                                    <div className="form-material">
                                        <label htmlFor="material-text">Credit Bundle</label>
                                        <Controller
                                            as={Select}
                                            control={control}
                                            name="bundle"
                                            options={orderedList}
                                            value={bundle}
                                        />
                                    </div>
                                </div>
                                {Number(bundle?.credits) == 1 &&
                                    <div className="col-sm-6" style={{ paddingLeft: 0 }}>
                                        <div className="form-material">
                                            <label htmlFor="material-text">Quantity</label>
                                            <input
                                                style={{ height: 36 }}
                                                value={quantity}
                                                onChange={(e) => {
                                                    if (!isNaN(e.target.value) && e.target.value >= 0) {
                                                        setQuantity(Number(e.target.value.trim()))
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                }
                                <div className="col-sm-12" style={{ paddingLeft: 0 }}>

                                    <div className="col-sm-3" style={{ paddingLeft: 0, marginTop: 20 }}>
                                        <div className="form-material">
                                            <label className="css-input switch switch-sm switch-success">
                                                <div style={{ paddingRight: 5, marginBottom: 2 }} htmlFor="material-text">Invoiceable</div>
                                                <input
                                                    type="checkbox"
                                                    // disabled={Number(bundle?.credits) != 1}
                                                    checked={invoiceable}
                                                    onChange={() => {
                                                        setInvoiceable(!invoiceable)
                                                    }}
                                                />
                                                <span></span>

                                            </label>
                                            <div className="clearfix"></div>
                                        </div>
                                    </div>
                                    {invoiceable &&
                                        <>
                                            <div className="col-sm-3" style={{ paddingLeft: 0, marginTop: 20 }}>
                                                <div className="form-material">
                                                    <label className="css-input switch switch-sm switch-success">
                                                        <div style={{ paddingRight: 5, marginBottom: 2 }} htmlFor="material-text">Create a New Invoice </div>
                                                        <input
                                                            type="checkbox"
                                                            checked={newInvoice}
                                                            onChange={() => {
                                                                setNewInvoice(!newInvoice)
                                                            }}
                                                        />
                                                        <span></span>

                                                    </label>
                                                    <div className="clearfix"></div>
                                                </div>
                                            </div>
                                            {!newInvoice &&
                                                <div className="col-sm-6" style={{ paddingLeft: 8 }}>
                                                    <div className="form-material" style={{ marginTop: 20 }}>
                                                        <label htmlFor="material-text">Invoice Number</label>
                                                        <input
                                                            style={{ height: 36 }}
                                                            value={invoiceNumber}
                                                            onChange={(e) => {
                                                                const number = e.target.value.replace('INV-', '')
                                                                if (e.target.value != '' && !isNaN(number) && number >= 0) {
                                                                    setInvoiceNumber(e.target.value.trim())
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            }
                                        </>
                                    }
                                </div>
                            </div>
                            <div className="block-content" style={{ padding: 20 }}>
                                <div className="col-sm-12" style={{ paddingLeft: 0, paddingTop: 20 }}>
                                    <label>Reference</label>
                                    <textarea
                                        className="form-control"
                                        type="text"
                                        name="reference"
                                        ref={register}
                                        style={{ minHeight: 100, maxHeight: 400, resize: "vertical" }}
                                    />
                                </div>
                            </div>
                        </div>
                        <button className="btn btn-success pull-right" type="submit" style={{ marginRight: 25, marginTop: 20, marginBottom: 20 }}>
                            <PlusIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
                            <div style={{ float: "left" }}>Issue Credits</div>
                        </button>
                        <div className="clearfix"></div>
                    </div>
                </div>
            </div>
        </form>
    )
}

const mapStateToProps = (state, ownProps) => {
    const currency = state.company?.settings?.currency

    const bundleList = state?.payment?.bundles?.map(bundle => ({
        label: `${bundle.name} + ${bundle.bonusCredits} Bonus Credits`,
        value: bundle.price,
        ...bundle
    }))

    const bundleEdited = [...[{ label: 'Custom', id: 1, credits: 1, value: 2, price: 2 }], ...bundleList || []]

    return {
        isModalOpen: state?.company?.billingModal == "Invoice",
        bundleList: bundleEdited,
        org: state?.payment?.stats,
        currency,
    };
};

const mapDispatchToProps = dispatch => ({
    closeModal: () => dispatch(COMPANYACTIONS.setBillingModal()),
    issueCredits: ({ invoiceNo, issueInvoice, bundleID, quantity, description, }) => dispatch(PAYMENTACTIONS.issueCredits({ invoiceNo, issueInvoice, bundleID, quantity, description, })),

});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(IssueInvoiceModal)